import { VexRoutes } from '@mele/template/interfaces';

export const appRoutes: VexRoutes = [
  {
    path: 'plan',
    loadChildren: () => import('./modules/plans/plans.routes')
  },
  {
    path: '',
    loadChildren: () => import('./modules/landing/landing.routes')
  }
];
